module.exports = __webpack_public_path__ + "img/paint-slice_02.8f1ff33b.jpg";